import {
  UPDATE_FILTER,
  RESET_FILTER,
  TOGGLE_UPLOADED_BY,
  TOGGLE_SORT_BY_SHOOT_TIME,
} from './albumPhotosFilterActions';
import { ALBUM_PHOTO_FILTERS } from '../../../../constants/albums';

export const initialState = {
  albumId: '',
  albumPhotoFilter: ALBUM_PHOTO_FILTERS.PUBLISHED,
  uploaderIds: [],
  sortByShootTime: false,
};

const albumPhotosFilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        albumPhotoFilter: action.albumPhotoFilter,
      };

    case TOGGLE_UPLOADED_BY:
      return {
        ...state,
        uploaderIds: state.uploaderIds.includes(action.uploaderId)
          ? state.uploaderIds.filter(
              uploaderId => uploaderId !== action.uploaderId,
            )
          : [...state.uploaderIds, action.uploaderId],
      };

    case TOGGLE_SORT_BY_SHOOT_TIME:
      return {
        ...state,
        sortByShootTime: !state.sortByShootTime,
      };

    case RESET_FILTER: {
      return { ...initialState, albumId: action.albumId };
    }

    default:
      return state;
  }
};

export default albumPhotosFilterReducer;
